import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

/* ------------------------------------------------------------------ */
/*  Context — ensures only one InsightPopover is open at a time        */
/* ------------------------------------------------------------------ */

interface InsightPopoverContextValue {
  openId: string | null;
  setOpenId: (id: string | null) => void;
}

const InsightPopoverContext = createContext<InsightPopoverContextValue>({
  openId: null,
  setOpenId: () => {},
});

/* ------------------------------------------------------------------ */
/*  Provider                                                           */
/* ------------------------------------------------------------------ */

export function InsightPopoverProvider({ children }: { children: ReactNode }) {
  const [openId, setOpenIdRaw] = useState<string | null>(null);

  const setOpenId = useCallback((id: string | null) => {
    setOpenIdRaw(id);
  }, []);

  return (
    <InsightPopoverContext.Provider value={{ openId, setOpenId }}>
      {children}
    </InsightPopoverContext.Provider>
  );
}

/* ------------------------------------------------------------------ */
/*  Hook                                                               */
/* ------------------------------------------------------------------ */

export function useInsightPopover() {
  return useContext(InsightPopoverContext);
}
